import React from "react";
import { Instagram } from "lucide-react";
import { FOOTER, NAV } from "../../content/home";
import { SmartLink } from "./shared";
import { Pause, Mix } from "./Reskin";

// Shared meditation sign-up (homepage, Our Story, UNBOUND) — re-skin "Take a pause with us." split panel.
export const Breathwork = ({ id = "breathwork", source = "homepage", copy }) => <Pause id={id} source={source} {...(copy ? { copy } : {})} />;

const COL = "feral-nav uppercase tracking-[0.08em] text-[11px] text-[#ebc754] mb-5";
const LINK = "text-[#f2e5de] text-sm hover:text-[#ebc754] transition-colors";

export const SiteFooter = () => (
  <footer className="bg-[#82254d] text-[#f2e5de] px-6 lg:px-[3.75rem] pt-20 md:pt-24 pb-10" data-testid="footer-section">
    <div className="max-w-[1500px] mx-auto grid md:grid-cols-12 gap-12">
      <div className="md:col-span-4">
        <img src="/skin/lockup-yellow.svg" alt="FERAL" className="h-28 md:h-32 w-auto" />
        <p className="mt-6 feral-display text-[#ebc754] text-2xl md:text-[1.9rem]" data-testid="footer-strapline"><Mix text="*be* FREE. *be* FERAL." /></p>
      </div>
      <div className="md:col-span-3">
        <p className={COL}>Contact</p>
        <a href={`mailto:${FOOTER.email}`} className={`${LINK} block`} data-testid="footer-email">{FOOTER.email}</a>
        <a href="mailto:events@feralcollective.co.uk" className={`${LINK} block mt-1`} data-testid="footer-events-email">events@feralcollective.co.uk</a>
        <p className="text-sm mt-1 text-[#f2e5de]/85">{FOOTER.location}</p>
        <div className="flex gap-3 mt-5">
          <a href={FOOTER.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="hover:text-[#ebc754]"><Instagram size={20} /></a>
        </div>
      </div>
      <nav className="md:col-span-3" aria-label="Footer">
        <p className={COL}>Top links</p>
        <div className="flex flex-col gap-1.5">
          {NAV.map((n) => <SmartLink key={n.label} to={n.to} className={LINK} data-testid={`footer-${n.testid}`}>{n.label}</SmartLink>)}
        </div>
      </nav>
      <div className="md:col-span-2">
        <p className={COL}>Useful links</p>
        <div className="flex flex-col gap-1.5">
          <a href={`mailto:${FOOTER.email}`} className={LINK} data-testid="footer-contact">Contact</a>
          <button onClick={() => { localStorage.removeItem("feral_cookie_consent"); window.dispatchEvent(new Event("feral-cookie-reset")); }} className={`${LINK} text-left`} data-testid="footer-cookie-settings">Cookie settings</button>
        </div>
      </div>
    </div>
    <p className="max-w-[1500px] mx-auto mt-16 text-xs text-[#f2e5de]/70">© {new Date().getFullYear()} FERAL Collective</p>
  </footer>
);
